// writeCookie = (nama, value, waktu) => 
// {
//     var date, expires;
//     if( waktu )
//     {
//         date = new Date();
//         date.setTime(date.getTime() + (waktu * 24 * 60 * 60 * 1000));
//         expires = "; expires=" + date.toGMTString();
//     }else{
//         expires = '';
//     }

//     document.cookie = nama + '=' + value + expires + "; path=/";
// }

class Cookie
{
    greeting(){
        console.log('Helllo');
    }
}

export class Write{

    constructor(nama, value, waktu)
    {
        this.nama = nama;
        this.value = value;
        this.waktu = waktu;

        var date, expires;
        if( this.waktu )
        {
            date = new Date();
            date.setTime(date.getTime() + (this.waktu * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toGMTString();
        }else{
            expires = '';
        }

        document.cookie = this.nama + '=' + this.value + expires + "; path=/";
    }
}

export class Read 
{
    constructor(name)
    {
        this.name = name;
    }
    baca(){
        var  c, ca, nameEQ = this.name + "=";
        ca = document.cookie.split(';');
        for( let i = 0; i < ca.length; i++ )
        {
            c = ca[i];
            while ( c.charAt(0) === ' ' )
            {
                c = c.substring(1, c.length);
            }
            if( c.indexOf(nameEQ) === 0 )
            {
                return c.substring(nameEQ.length, c.length);
            }
        }

        return '';
    }
}

export default Cookie;